import type { CustomerLoginRouterScope } from "@Front/Components/Layouts/Login/helpers/customerLoginRouterScope";
import type { CustomerLoginState } from "@Front/Components/Layouts/Login/hooks/helpers/loginStateHook";
import type { MailVerifySmsScopeOpts } from "@Front/Components/Layouts/Login/hooks/helpers/loginEmailSubmissionExecution";

export function mailVerifyScopeFromLoginState(
	scope: CustomerLoginRouterScope,
	s: Pick<
		CustomerLoginState,
		| "setPartialPhoneNumber"
		| "setDeliveryChannel"
		| "setMaskedEmail"
		| "setTotpCodeUid"
		| "setStep"
		| "setValidationErrors"
		| "setLoginCandidates"
	>,
): MailVerifySmsScopeOpts {
	return {
		...scope,
		setPartialPhoneNumber: s.setPartialPhoneNumber,
		setDeliveryChannel: s.setDeliveryChannel,
		setMaskedEmail: s.setMaskedEmail,
		setTotpCodeUid: s.setTotpCodeUid,
		setStep: s.setStep,
		setValidationErrors: s.setValidationErrors,
		setLoginCandidates: s.setLoginCandidates,
	};
}

export async function withDisambiguationBusy(setBusy: (v: boolean) => void, fn: () => Promise<void>): Promise<void> {
	setBusy(true);
	try {
		await fn();
	} finally {
		setBusy(false);
	}
}
